<template>
  <v-app>
    <router-view name="navigationDrawer" />
    <router-view name="appBar" />

    <v-main class="blue-grey lighten-5">
      <v-container>
        <router-view />
      </v-container>
    </v-main>

    <the-notification />
    <the-confirm-dialog ref="confirm" />
  </v-app>
</template>

<script>
import TheNotification from '@/components/layout/TheNotification.vue'
import TheConfirmDialog from '@/components/layout/TheConfirmDialog.vue'

export default {
  name: 'App',

  components: {
    TheNotification,
    TheConfirmDialog,
  },

  data: () => ({
    drawer: true,
    mini: true,
  }),

  mounted() {
    this.$root.$confirm = this.$refs.confirm.open
  },
}
</script>

<style lang="scss">
// .theme--light.v-application {
//   background: pink;
//   color: rgba(0, 0, 0, 0.67);
// }

.v-application .v-sheet.v-app-bar.v-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important ;
}
</style>
